import { LookupRecord, ProductResolutionSchemaDefinition, ResolutionSchemaDefinition } from '../lookup/ResolutionSchemaDefinition.js';
import { TypeReference } from '../types.js';
import { ResolutionSchema } from '../lookup/ResolutionSchema.js';
import { SchemaError } from '../errors/SchemaError.js';


export class ResolutionSchemaParser {
  private result: Map<TypeReference, ResolutionSchema>;

  constructor(
    private resolutionSchemaDefinition: Partial<ResolutionSchemaDefinition>,
    private registeredTypes: Set<TypeReference>) {
  }

  parse(): Map<TypeReference, ResolutionSchema> {
    this.result = new Map<TypeReference, ResolutionSchema>();
    this.parseProducts();
    return this.result;
  }

  private parseProducts() {
    if (Array.isArray(this.resolutionSchemaDefinition.products)) {
      for (let i = 0; i < this.resolutionSchemaDefinition.products.length; i++) {
        let resolutionSchemaDeclaration = this.resolutionSchemaDefinition.products[i];
        this.parseProductResolutionSchemaDefinition(resolutionSchemaDeclaration, i);
      }
    } else throw SchemaError.invalidResolutionSchemaProductsDefinition();
  }

  private parseProductResolutionSchemaDefinition(definition: ProductResolutionSchemaDefinition, index: number) {
    if (!definition.type) {
      throw SchemaError.productResolutionSchemaTypedMissed(index);
    }
    if (!this.registeredTypes.has(definition.type)) {
      throw SchemaError.invalidTypeInProductResolutionSchema(definition.type, index);
    }
    //TODO: Add more validations
    const lookups: LookupRecord[] = definition.resolutionSchema.lookups;
    for (const lookup of lookups) {
      this.validateLookup(lookup);
    }
    const resolutionSchema = new ResolutionSchema(lookups);
    this.result.set(definition.type, resolutionSchema);
  }

  private validateLookup(lookup: LookupRecord) {
    if (!lookup.variation) {
      //TODO: implement
      lookup.variation = [];
      // throw new Error(`Variation is missing ${lookup.id}`)
    }
    if (!lookup.filterGroup) {
      lookup.filterGroup = '';
    }
  }
}
